import {loadStripe} from '@stripe/stripe-js';

export const stripePromise = loadStripe(
    "pk_test_51KtnDTSCPeNCmTapgkNgNEb6U2HOqmC7bMK88AWE2QFZYfYBjg2JcfGRyeJW1I7lC4522FX02oFUxA74gnlVuLhv001VAeQSqD"
  );
export const options = {
    // passing the client secret obtained from the server
    clientSecret:
      "sk_test_51KtnDTSCPeNCmTapyOjZgdIQwvyGW2pocD3k7zHktC2CyPcxC3XuK94uttYZ7couA8UN3mFLCq1rqCp7tF6BWFqo008Piubs4M",
  };